<td>
    <!-- Included in Flyer / Create Schedule -->
    @if (item.showInClientSpecification) {
        <mat-icon
            class="cb-grey cb-help-cursor"
            aria-hidden="false"
            matTooltip="Included in Flyer / Create Schedule"
        >
            style
        </mat-icon>
    }

    <!-- Included in Colour Schedule -->
    @if (item.showInColourYourDreams) {
        <mat-icon
            class="cb-grey cb-help-cursor"
            svgIcon="book-open-page-variant"
            matTooltip="Included in Colour Schedule"
        >
        </mat-icon>
    }

    <!-- Descriptive -->
    @if (item.costType === costTypeEnum.DescriptiveOnly) {
        <mat-icon class="cb-grey cb-help-cursor" aria-hidden="false" matTooltip="Descriptive Only">
            notes
        </mat-icon>
    }

    <!-- Offering Status -->
    @if (
        item?.product?.id > 0 &&
        item?.product?.offeringStatus === offeringStatusEnum.Active &&
        item.costType === costTypeEnum.Actual
    ) {
        <mat-icon class="mat-primary cb-help-cursor" aria-hidden="false" matTooltip="Available">
            check_circle
        </mat-icon>
    }
    @if (
        item?.product?.offeringStatus === offeringStatusEnum.TemporarilyUnavailable &&
        item.costType === costTypeEnum.Actual
    ) {
        <mat-icon
            class="mat-warn cb-help-cursor"
            aria-hidden="false"
            matTooltip="Temporarily Unavailable"
        >
            warning
        </mat-icon>
    }
    @if (
        item?.product?.offeringStatus === offeringStatusEnum.PermanentlyUnavailable &&
        item.costType === costTypeEnum.Actual
    ) {
        <mat-icon
            class="cb-error cb-help-cursor"
            aria-hidden="false"
            matTooltip="Permanently Unavailable"
        >
            error
        </mat-icon>
    }
</td>
<td>
    @if (item?.childItems?.length > 0) {
        <button mat-icon-button (click)="expandedParents[item.id] = !expandedParents[item.id]">
            <mat-icon>
                {{
                    expandedParents[item.id] && item.childItems?.length
                        ? 'arrow_drop_up'
                        : 'arrow_drop_down'
                }}
            </mat-icon>
        </button>
    }
</td>
<cb-td-text [value]="item.slotName"></cb-td-text>
<cb-td-list [list]="item.tags"></cb-td-list>
@if (!lotSpecificationService.hasQuoteLineId(item)) {
    <cb-td-text [value]="item?.product?.productCode"> </cb-td-text>
}
@if (lotSpecificationService.hasQuoteLineId(item)) {
    <cb-td-text [value]="getQRef()"> </cb-td-text>
}
<td class="start-center">
    <span class="start-center">
        <cb-td-text [value]="lotSpecificationService.getProductName(item)"></cb-td-text>
        <cb-info-popup [tooltip]="item?.clientFriendlyDescription"></cb-info-popup>
        @if (item?.generatedByVariationNumber) {
            <span
                id="variation"
                class="help-cursor"
                [matTooltip]="'Variation Number: ' + item?.generatedByVariationNumber"
                >VO
                {{ item?.generatedByVariationNumber }}
            </span>
        }
    </span>
</td>
<td>
    <cb-td-enum [value]="item.costType" [enum]="costTypeEnum"> </cb-td-enum>
</td>
<td>
    <cb-td-text [value]="item.quantity"></cb-td-text>
</td>
@if (!isSkinnyView) {
    <td>
        <button mat-icon-button [matMenuTriggerFor]="optionMenu">
            <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #optionMenu="matMenu">
            @if (lotSpecificationService.hasQuoteLineId(item)) {
                <button mat-menu-item (click)="quoteRefsDialog()">
                    <mat-icon>pageview</mat-icon>
                    Q Refs
                </button>
            }
            <button mat-menu-item (click)="editItem()">
                <mat-icon>edit</mat-icon>
                <span>Edit Item</span>
            </button>
            @if (lotSpecificationService.hasQuoteLineId(item)) {
                <button mat-menu-item (click)="abandonQuoteLine()">
                    <mat-icon>remove_circle</mat-icon>
                    <span>Abandon Quote Line</span>
                </button>
            }
            @if (uiActions.canChangeSpecification()) {
                <button mat-menu-item (click)="removeItem()" [disabled]="!item.isDeleteAllowed">
                    <mat-icon>remove_circle</mat-icon>
                    <span>Remove Item</span>
                </button>
            }
        </mat-menu>
    </td>
}
